import { Alignments } from 'rich-text-lib/constants/alignments';
export const TableAlignmentClasses = {
  [Alignments.LEFT]: 'hs-table-align-left',
  [Alignments.RIGHT]: 'hs-table-align-right',
  [Alignments.CENTER]: 'hs-table-align-center',
  [Alignments.NONE]: 'hs-table-align-none'
};
export const CELL_VERTICAL_ALIGNMENTS = ['top', 'middle', 'bottom'];
export const CELL_HORIZONTAL_ALIGNMENTS = ['left', 'center', 'right'];
export const TABLE_SETTINGS = 'hsTableV2';
export const hstableConfig = {
  MAX_DIMENSION_WIDTH: 'maxTableWidth',
  HIDE_CELL_COLOR_OPTIONS: 'hideCellColorOptions',
  DEFAULT_CELL_STYLES: 'defaultCellStyles',
  USE_ALIGNMENT_CLASSES: 'useAlignmentClasses',
  USE_RESPONSIVE_TABLES: 'useResponsiveTables',
  DISABLE_SPACING: 'tableDisableSpacing'
};
export const TableAlignmentStyles = {
  [Alignments.LEFT]: {
    float: 'left',
    'margin-left': '0px',
    'margin-right': '10px',
    display: null
  },
  [Alignments.CENTER]: {
    float: null,
    'margin-left': 'auto',
    'margin-right': 'auto',
    display: null
  },
  [Alignments.RIGHT]: {
    float: 'right',
    'margin-left': '10px',
    'margin-right': '0px',
    display: null
  },
  [Alignments.NONE]: {
    float: null,
    'margin-left': null,
    'margin-right': null,
    display: null
  }
};
export const TableAlignmentFormats = {
  alignleft: Alignments.LEFT,
  alignright: Alignments.RIGHT,
  aligncenter: Alignments.CENTER,
  alignfull: Alignments.NONE
};